<div class="sign-in-password-rules-container">
  <div class="sign-in-password-rules-rule">
    <mat-icon class="sign-in-password-rules-icon" [textContent]="errors?.format.size ? 'error' : 'check'" [class.checked]="!errors?.format.size"></mat-icon>
    <span>{{ 'SIGN_IN.HELP_MESSAGE.SIZE' | translate }}</span>
  </div>
  <div class="sign-in-password-rules-rule">
    <mat-icon
      class="sign-in-password-rules-icon"
      [textContent]="errors?.format.lowercase ? 'error' : 'check'"
      [class.checked]="!errors?.format.lowercase"
    ></mat-icon>
    <span>{{ 'SIGN_IN.HELP_MESSAGE.LOWERCASE' | translate }}</span>
  </div>
  <div class="sign-in-password-rules-rule">
    <mat-icon
      class="sign-in-password-rules-icon"
      [textContent]="errors?.format.uppercase ? 'error' : 'check'"
      [class.checked]="!errors?.format.uppercase"
    ></mat-icon>
    <span>{{ 'SIGN_IN.HELP_MESSAGE.UPPERCASE' | translate }}</span>
  </div>
  <div class="sign-in-password-rules-rule">
    <mat-icon class="sign-in-password-rules-icon" [textContent]="errors?.format.number ? 'error' : 'check'" [class.checked]="!errors?.format.number"></mat-icon>
    <span>{{ 'SIGN_IN.HELP_MESSAGE.NUMBER' | translate }}</span>
  </div>
  <div class="sign-in-password-rules-rule">
    <mat-icon class="sign-in-password-rules-icon" [textContent]="errors?.format.special ? 'error' : 'check'" [class.checked]="!errors?.format.special"></mat-icon>
    <span>{{ 'SIGN_IN.HELP_MESSAGE.SPECIAL' | translate }}</span>
  </div>
</div>
